module.exports = __webpack_public_path__ + "3329fb381b57830d64ce6d73d9041bc0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/ear-muffs-gray-s.png
// module id = 2794
// module chunks = 0